module.exports = __webpack_public_path__ + "img/CREDIT.68b0878a.png";